export default {
  namespaced: true,
  state: {
    distributedTotal: '',
    pendingTotal: '',
    processingTotal: '',
    processedTotal: '',
    completedTotal: '',
    closeTotal: '',
    workOrderId: '',
    followOrder: '',
    processedBtn: ''
  },
  getters: {
    getWorkOrderId(state) {
      return state.workOrderId
    },
    getDistributedTotal(state) {
      return state.distributedTotal
    },
    getPendingTotal(state) {
      return state.pendingTotal
    },
    getCloseTotal(state) {
      return state.closeTotal
    },
    getProcessingTotal(state) {
      return state.processingTotal
    },
    getCompletedTotal(state) {
      return state.completedTotal
    },
    getProcessedTotal(state) {
      return state.processedTotal
    },
    getFollowOrder(state) {
      return state.followOrder
    },
    getProcessedBtn(state) {
      return state.processedBtn
    }
  },
  mutations: {
    setProcessedBtn: (state, processedBtn) => {
      state.processedBtn = processedBtn
    },
    setWorkOrderId: (state, workOrderId) => {
      state.workOrderId = workOrderId
    },
    setDistributedTotal: (state, distributedTotal) => {
      state.distributedTotal = distributedTotal
    },
    setPendingTotal: (state, pendingTotal) => {
      state.pendingTotal = pendingTotal
    },
    setCloseTotal: (state, closeTotal) => {
      state.closeTotal = closeTotal
    },
    setProcessingTotal: (state, processingTotal) => {
      state.processingTotal = processingTotal
    },
    setCompletedTotal: (state, completedTotal) => {
      state.completedTotal = completedTotal
    },
    setProcessedTotal: (state, processedTotal) => {
      state.processedTotal = processedTotal
    },
    setFollowOrder: (state, followOrder) => {
      state.followOrder = followOrder
    }
  },
  actions: {}
}
